import {Websocket} from "./websocket.js";
import type {NewNotificationEvent} from "../../../nodeserver/structs/websocket";
import {incrementCounter, playAudio, showNotice} from "./helpers/functions.js";

class Notifications{
    public newNotification = (ev: NewNotificationEvent) =>{
        //TODO: add some new interface
        showNotice(ev.message.text_html, ev.message.title_html, 'normal', true, ()=>{
            window.location.href = ev.message.click_uri;
        });
        incrementCounter('.notification-btn');
        playAudio('notification');
    }
    public static Instance = new Notifications();
}
Websocket.Instance.on<NewNotificationEvent>('notification', Notifications.Instance.newNotification);
export {Notifications};